import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ProductDetailsContent from "./ProductDetailsContent";

import { getProviderDataByProduct } from "../../../api/fedRamp";
import { GENERIC_ERROR_STRING } from "../../../constants";

/**
 * FedRamp Product Details Modal
 * @param {Object} props
 * @param {number} props.productSeq
 * @param {function} props.closeModal
 * @param {boolean} props.isLoggedIn
 * @returns {Element}
 * @constructor
 */
export default function ProductDetails({ productSeq, closeModal, isLoggedIn }) {
  const [productDetails, setProductDetails] = useState(/** @type FedRampProductViewModel*/null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setProductDetails(null);
    getProviderDataByProduct(productSeq).then(({ data }) => {
      setProductDetails(data);
    }).catch(error => {
      setError(error);
    });
  }, [productSeq]);

  let modalContent;

  if (error) {
    modalContent = <p>{GENERIC_ERROR_STRING}</p>;
  } else if (productDetails) {
    modalContent = <ProductDetailsContent productDetails={productDetails} isLoggedIn={isLoggedIn}/>;
  } else {
    modalContent = <p>Loading Product Details</p>;
  }

  return (<Dialog open={true} onClose={closeModal}>
    <DialogTitle sx={{ m: 0, p: 2, color: "white", backgroundColor: "#2D5986", padding: "8px 16px" }}>
      Product Details
    </DialogTitle>
    <IconButton
      aria-label="close"
      onClick={closeModal}
      sx={{
        position: "absolute", right: 0, top: 0, color: "white",
      }}
    >
      <CloseIcon/>
    </IconButton>
    <DialogContent>
      {modalContent}
    </DialogContent>
  </Dialog>);
}

ProductDetails.propTypes = {
  productSeq: PropTypes.number.isRequired, closeModal: PropTypes.func.isRequired, isLoggedIn: PropTypes.bool.isRequired,
};